import React, { useState, useEffect } from "react";
import Datepicker from "../../fixedassetelements/datepicker/Datepicker";
import {
  AddregButton,
  FilterIcon,
  SyncButton,
  UploadFileButton,
} from "../../fixedassetelements/button/Button";

import SyncPopup from "../SyncButton/SyncButton";
import UploadExcelModal from "../common/UploadExcelModal/UploadExcelModal";
import CustomFilter from "../filterIcon/CustomFilter";
import AddPayableRegister from "../Forms/AddPayablesRegister/AddPayableRegister";
import UploadPayableFile from "../Forms/UploadPayableFile/UploadPayableFile";
import PayableUploadedFiles from "../Forms/PayableUploadedFiles/PayableUploadedFile";
import ColumnMapping from "../Forms/ColumnMappingForm/ColumnMapping";
import Submapping from "../Forms/SubMapping/Submapping";
import ERPModal from "../common/ERPModal/ERPModal";
import SyncERPSuccess from "../SyncButton/SyncERPSuccess";
import AppendReplaceFile from "../common/AppendReplacePopup/AppendReplacePopup";
import { getPayableListing } from "../../../Bookclosure/Services/ApiHandler";

import styles from "./Header.module.css";

const PayablesHeaders = ({
  setShowDataState,
  tableType,
  setTableType,
  setShowTable,
  onFiltersApplied,
  showAddRegisterModal,
  setShowAddRegisterModal,
}) => {
  const [fromDate, setFromDate] = useState("2024-01-01");
  const [toDate, setToDate] = useState("2025-01-01");

  
  const [showUploadExcelModal, setShowUploadExcelModal] = useState(false);
  const [showUploadFileModal, setShowUploadFileModal] = useState(false);
  const [showPayableUploadedFiles, setShowPayableUploadedFiles] = useState(false);
  const [showColumnMapping, setShowColumnMapping] = useState(false);
  const [showSubMapping, setShowSubMapping] = useState(false);
  const [showERPModal, setShowERPModal] = useState(false);
  const [showERPSuccessModal, setShowERPSuccessModal] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [showAppendReplacePopup, setShowAppendReplacePopup] = useState(false);

  const [uploadAction, setUploadAction] = useState(null);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [PayableID] = useState("690c45d4a61585aa464338ea");
  const [uploadType, setUploadType] = useState(null);

  const [filterConfig, setFilterConfig] = useState([]);

  useEffect(() => {
    const fetchFilterConfig = async () => {
      try {
        const response = await getPayableListing(PayableID, {
          page: 1,
          pageSize: 30,
          filters: [],
        });

        if (response.data && response.data.filterAndAlignment) {
          setFilterConfig(response.data.filterAndAlignment);
        }
      } catch (error) {
        console.error("Failed to fetch filter config:", error);
      }
    };

    if (PayableID) {
      fetchFilterConfig();
    }
  }, [PayableID]);

  const handleRemoveFile = (index) => {
    setUploadedFiles((prev) => {
      console.log("Removed file:", prev[index]?.name);
      const newFiles = prev.filter((_, i) => i !== index);
      return newFiles;
    });
  };

  const handleApplyFilter = (filters) => {
    console.log("Filters received:", filters);
    setShowFilter(false);

    setShowTable(true);
    setShowDataState(false);

    if (onFiltersApplied) {
      onFiltersApplied(filters);
    }
  };

  const handleSelect = (type) => {
    if (type === "uploadExcelModal") {
      setShowAddRegisterModal(false);
      setShowUploadExcelModal(true);
    } else if (type === "erp") {
      setShowAddRegisterModal(false);
      setShowERPModal(true);
    }
  };

  const handleChangeFile = () => {
    setShowUploadExcelModal(true);
    setShowUploadFileModal(false);
  };

  const handleSelectUploadType = (type) => {
    setUploadType(type);
    setShowUploadExcelModal(false);
    setShowUploadFileModal(true);
  };

  const handleAddFiles = () => {
    setShowUploadFileModal(true);
    setShowPayableUploadedFiles(false);
  };

  const handleProceedToPayableUploadedFiles = (files) => {
    setUploadedFiles(files);
    setShowUploadFileModal(false);
    setShowPayableUploadedFiles(true);
  };

  const handleStartMapping = () => {
    setShowPayableUploadedFiles(false);
    setShowColumnMapping(true);
  };

  const handleContinueMapping = () => {
    setShowColumnMapping(false);
    setShowSubMapping(true);
  };

  const handleSubmitSubMapping = () => {
    setShowSubMapping(false);
    setShowPayableUploadedFiles(true);
  };

  const handleFinish = () => {
    setShowPayableUploadedFiles(false);
    setShowDataState(false);
    setTableType("excel");
    setShowTable(true);
  };

  const handleSuccessERPModal = () => {
    setShowERPModal(false);
    setShowERPSuccessModal(true);
  };

  const handleERPComplete = () => {
    setShowERPSuccessModal(false);
    setShowDataState(false);
    setTableType("erp");
    setShowTable(true);
  };

  const handleAppendReplaceSelect = (action) => {
    setUploadAction(action);
    setShowAppendReplacePopup(false);
    setShowUploadExcelModal(true);
  };

  return (
    <>
      <div className={styles.header}>
        <div className={styles.rightSection}>
          <FilterIcon onClick={() => setShowFilter(true)} />

          <Datepicker
            fromDate={fromDate}
            toDate={toDate}
            onFromChange={(e) => setFromDate(e.target.value)}
            onToChange={(e) => setToDate(e.target.value)}
          />

          {tableType === "erp" && (
            <SyncButton onClick={() => setShowPopup(true)} />
          )}
          {tableType === "excel" && (
            <UploadFileButton onClick={() => setShowAppendReplacePopup(true)} />
          )}
          {tableType === null && (
            <AddregButton onClick={() => setShowAddRegisterModal(true)} />
          )}
        </div>
      </div>

      {showAddRegisterModal && (
        <AddPayableRegister
          onClose={() => setShowAddRegisterModal(false)}
          handleSelect={handleSelect}
        />
      )}

      {showUploadExcelModal && (
        <UploadExcelModal
          onClose={() => setShowUploadExcelModal(false)}
          onBack={() => {
            setShowUploadExcelModal(false); 
            setShowAddRegisterModal(true);
          }}
          onSelectUploadType={handleSelectUploadType}
        />
      )}

      {showUploadFileModal && (
        <UploadPayableFile
          PayableID={PayableID}
          onClose={() => setShowUploadFileModal(false)}
          onBack={() => {
            setShowUploadFileModal(false);
            setShowUploadExcelModal(true);
          }}
          onChangeFile={handleChangeFile}
          onProceedToPayableUploadedFiles={handleProceedToPayableUploadedFiles}
        />
      )}

      {showPayableUploadedFiles && (
        <PayableUploadedFiles
          uploadedFiles={uploadedFiles}
          onBack={() => {
            setShowPayableUploadedFiles(false);
            setShowUploadFileModal(true);
          }}
          onAdd={handleAddFiles}
          onStartMapping={handleStartMapping}
          onFinish={handleFinish}
          onRemove={handleRemoveFile}
          onClose={() => setShowPayableUploadedFiles(false)}
        />
      )}

      {showColumnMapping && (
        <ColumnMapping
          PayableID={PayableID}
          onBack={() => {
            setShowColumnMapping(false);
            setShowPayableUploadedFiles(true);
          }}
          onContinue={handleContinueMapping}
          onCancel={() => {
            setShowColumnMapping(false);
          }}
          onClose={() => {
            setShowColumnMapping(false);
          }}
        />
      )}

      {showSubMapping && (
        <Submapping
          PayableID={PayableID}
          onBack={() => {
            setShowSubMapping(false);
            setShowColumnMapping(true);
          }}
          onClose={() => {
            setShowSubMapping(false);
          }}
          onCancel={() => {
            setShowSubMapping(false);
          }}
          onSubmitMapping={handleSubmitSubMapping}
        />
      )}

      {showERPModal && (
        <ERPModal
          onClose={() => setShowERPModal(false)}
          onBack={() => {
            setShowERPModal(false);
            setShowAddRegisterModal(true);
          }}
          onProceed={handleSuccessERPModal}
        />
      )}

      {showERPSuccessModal && <SyncERPSuccess onClose={handleERPComplete} />}

      {showFilter && (
        <CustomFilter
          onClose={() => setShowFilter(false)}
          onApply={handleApplyFilter}
          filterConfig={filterConfig}
        />
      )}

      {showPopup && <SyncPopup onClose={() => setShowPopup(false)} />}

      {showAppendReplacePopup && (
        <AppendReplaceFile
          onClose={() => setShowAppendReplacePopup(false)}
          onSelectUploadType={handleAppendReplaceSelect}
        />
      )}
    </>
  );
};

export default PayablesHeaders;